<template>
  <div class="contact-page">

    <!-- Hero with form -->
    <section class="contact-hero">
      <div class="container">
        <div class="contact-hero__grid">
          <div class="contact-hero__left">
            <h1 class="contact-hero__title">{{ hero_title }}</h1>
            <p class="contact-hero__desc">{{ hero_desc_1 }}</p>
            <p class="contact-hero__desc">{{ hero_desc_2 }}</p>
          </div>

          <div class="contact-form-card">
            <h2 class="contact-form-card__title">{{ form_title }}</h2>

            <!-- Success state -->
            <div v-if="sent" class="contact-success">
              <i class="fa fa-check-circle contact-success__icon"></i>
              <p class="contact-success__msg">{{ success_msg }}</p>
              <p class="contact-success__sub">{{ success_sub }}</p>
            </div>

            <!-- Form -->
            <form v-else class="contact-form" @submit.prevent="submit">
              <div class="contact-form__row">
                <div class="contact-form__field">
                  <label class="contact-form__label">First name</label>
                  <input v-model="form.firstName" required placeholder="First name" class="contact-form__input" />
                </div>
                <div class="contact-form__field">
                  <label class="contact-form__label">Last name</label>
                  <input v-model="form.lastName" required placeholder="Last name" class="contact-form__input" />
                </div>
              </div>
              <div class="contact-form__field">
                <label class="contact-form__label">Email address</label>
                <input v-model="form.email" required type="email" placeholder="Email address" class="contact-form__input" />
              </div>
              <div class="contact-form__field">
                <label class="contact-form__label">Your message</label>
                <textarea v-model="form.message" required rows="5" class="contact-form__input contact-form__textarea"></textarea>
              </div>
              <button type="submit" class="contact-form__btn">
                <i class="fa fa-paper-plane"></i> Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- Offices -->
    <section class="contact-offices">
      <div class="container">
        <h2 class="contact-offices__title">{{ offices_title }}</h2>
        <p class="contact-offices__desc">{{ offices_desc }}</p>
        <div class="contact-offices__grid">
          <div v-for="o in offices" :key="o.city" class="contact-office">
            <div class="contact-office__pin"><i class="fa fa-map-marker"></i></div>
            <div class="contact-office__city">{{ o.city }}</div>
            <div class="contact-office__country">{{ o.country }}</div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { cmsContact } from '@/services/cms';
export default {
  metaInfo: { title: "Contact SherlockIT — Get in touch" },
  data() {
    return {
      sent: false,
      form: { firstName: "", lastName: "", email: "", message: "" },
      hero_title:    "Get in Touch with SherlockIT",
      hero_desc_1:   "The most efficient way to contact us is through the form. Whether you are a valued customer, a prospective B2B partner, or have any other inquiry, submitting the form ensures your request is routed to the right team member quickly and accurately.",
      hero_desc_2:   "We look forward to hearing from you and will respond as soon as possible.",
      form_title:    "Contact Us",
      success_msg:   "Thanks — your message is on its way.",
      success_sub:   "We typically reply within one business day.",
      offices_title: "Contact SherlockIT — Global Corporate Intelligence Platform",
      offices_desc:  "SherlockIT is a leading global corporate intelligence and risk management platform with a truly international footprint. Our expert teams operate from strategic locations around the world, including:",
      offices: [
        { city: "London",    country: "United Kingdom" },
        { city: "Porto",     country: "Portugal"       },
        { city: "Doha",      country: "Qatar"          },
        { city: "Colombo",   country: "Sri Lanka"      },
        { city: "Kathmandu", country: "Nepal"          },
      ],
    };
  },
  async mounted() {
    const applyContact = (cms) => {
      const fields = ['hero_title','hero_desc_1','hero_desc_2','form_title','success_msg','success_sub','offices_title','offices_desc'];
      fields.forEach(f => { if (cms[f]) this[f] = cms[f]; });
      if (cms.offices?.length) this.offices = cms.offices;
    };
    const cms = await cmsContact(this.$data, applyContact.bind(this));
    applyContact(cms);
  },
  methods: {
    submit() { this.sent = true; },
  },
};
</script>

<style scoped>
.contact-page { background: oklch(0.985 0.004 240); }

/* Hero */
.contact-hero { background: #0a1428; color: #fff; padding: 40px 0 80px; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
.contact-hero__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: start; }
.contact-hero__title { font-size: clamp(1.75rem, 3.5vw, 2.75rem); font-weight: 600; letter-spacing: -0.02em; color: #fff; margin-bottom: 24px; line-height: 1.15; }
.contact-hero__desc { font-size: 1rem; color: rgba(255,255,255,0.8); line-height: 1.7; max-width: 480px; margin-bottom: 16px; }

/* Form card */
.contact-form-card { background: #fff; border-radius: 20px; box-shadow: 0 20px 60px rgba(0,0,0,0.25); padding: 28px 32px; color: #0a1428; }
.contact-form-card__title { font-size: 1.15rem; font-weight: 600; color: #0a1428; text-align: center; padding-bottom: 16px; margin-bottom: 20px; border-bottom: 1px solid #e2e8f0; }

/* Success */
.contact-success { padding: 40px 0; text-align: center; }
.contact-success__icon { font-size: 40px; color: #575ECF; display: block; margin-bottom: 12px; }
.contact-success__msg { font-size: 15px; font-weight: 500; color: #0a1428; margin-bottom: 4px; }
.contact-success__sub { font-size: 13px; color: #64748b; }

/* Form */
.contact-form { display: flex; flex-direction: column; gap: 16px; }
.contact-form__row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.contact-form__field { display: flex; flex-direction: column; gap: 4px; }
.contact-form__label { font-size: 12px; font-weight: 500; color: #64748b; }
.contact-form__input { width: 100%; border: 1px solid #e2e8f0; border-radius: 8px; background: #f8fafc; padding: 8px 12px; font-size: 14px; color: #0a1428; outline: none; transition: box-shadow 0.15s, border-color 0.15s; box-sizing: border-box; }
.contact-form__input::placeholder { color: #94a3b8; }
.contact-form__input:focus { border-color: rgba(87,94,207,0.4); box-shadow: 0 0 0 3px rgba(87,94,207,0.1); }
.contact-form__textarea { resize: vertical; }
.contact-form__btn { width: 100%; display: inline-flex; align-items: center; justify-content: center; gap: 8px; background: #575ECF; color: #fff; border: none; border-radius: 8px; padding: 10px 16px; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; cursor: pointer; transition: background 0.15s; }
.contact-form__btn:hover { background: #4750b8; }

/* Offices */
.contact-offices { padding: 64px 0 80px; }
.contact-offices__title { font-size: 1.5rem; font-weight: 600; color: #0a1428; letter-spacing: -0.01em; margin-bottom: 12px; }
.contact-offices__desc { font-size: 1rem; color: #64748b; max-width: 720px; line-height: 1.7; margin-bottom: 40px; }
.contact-offices__grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 24px; }
.contact-office { display: flex; flex-direction: column; align-items: center; text-align: center; }
.contact-office__pin { width: 56px; height: 56px; border-radius: 50%; background: #575ECF; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 22px; margin-bottom: 12px; box-shadow: 0 4px 12px rgba(87,94,207,0.3); }
.contact-office__city { font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; color: #0a1428; margin-bottom: 2px; }
.contact-office__country { font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; }

/* Responsive */
@media (max-width: 768px) {
  .contact-hero__grid { grid-template-columns: 1fr; }
  .contact-offices__grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 480px) {
  .contact-form__row { grid-template-columns: 1fr; }
  .contact-offices__grid { grid-template-columns: repeat(2, 1fr); }
}
</style>
